(function () {
  function moveWeglotToFooter() {
    var mount = document.querySelector('#main-footer .footer__weglot-mount');
    var weglot =
      document.querySelector('#main-footer .footer__weglot-mount .weglot-container') ||
      document.querySelector('.header__right .weglot-container') ||
      document.querySelector('.weglot-container') ||
      document.querySelector('#weglot-switcher') ||
      document.querySelector('.weglot_switcher');
    if (!mount || !weglot) return;
    if (!mount.contains(weglot)) mount.appendChild(weglot);
    bindClick(mount);
  }

  function isClickOpen(aside) {
    return aside.getAttribute('data-fd-open') === 'true';
  }

  function setExpanded(aside, open) {
    var current = aside.querySelector('.wgcurrent');
    if (current) current.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeSwitcher(aside) {
    aside.removeAttribute('data-fd-open');
    setExpanded(aside, false);
  }

  function openSwitcher(aside) {
    aside.setAttribute('data-fd-open', 'true');
    setExpanded(aside, true);
  }

  function bindClick(mount) {
    var aside = mount.querySelector('.country-selector');
    if (!aside || aside.dataset.fdWeglotClick === '1') return;
    aside.dataset.fdWeglotClick = '1';
    closeSwitcher(aside);

    aside.addEventListener(
      'click',
      function (event) {
        if (event.target.closest('ul a, ul .wg-li')) return;
        if (!event.target.closest('.wgcurrent')) return;
        event.preventDefault();
        event.stopPropagation();
        if (isClickOpen(aside)) {
          closeSwitcher(aside);
        } else {
          openSwitcher(aside);
        }
      },
      true
    );

    document.addEventListener('click', function (event) {
      if (!aside.contains(event.target)) closeSwitcher(aside);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSwitcher(aside);
    });
  }

  moveWeglotToFooter();
  document.addEventListener('DOMContentLoaded', moveWeglotToFooter);
  window.addEventListener('load', moveWeglotToFooter);
  if (document.body) {
    new MutationObserver(moveWeglotToFooter).observe(document.body, { childList: true, subtree: true });
  }
})();
